import React, { useContext } from 'react';
import clsx from 'clsx';
import { AppLayoutContext } from './context';
import styles from './styles.css.js';
export default function Header() {
    var _a = useContext(AppLayoutContext), breadcrumbs = _a.breadcrumbs, contentHeader = _a.contentHeader, notifications = _a.notifications;
    if (!contentHeader) {
        return null;
    }
    return (React.createElement("header", { className: clsx(styles.content, 'awsui-context-content-header'), "data-has-breadcrumbs": breadcrumbs ? true : false, "data-has-notifications": notifications ? true : false }, contentHeader));
}
